import { DuplicateEventsByEventId } from "@ac-expo/api-types";
import { useQuery } from "@tanstack/react-query";
import { privateAxios } from "../axiosInstances";
import { potentialDuplicateEventsQueryKeys } from "../query-keys";

const getAllPotentialDuplicateEvents = async () => {
  const { data } = await privateAxios.get<{
    duplicateEventsByEventId: DuplicateEventsByEventId;
    count: number;
  }>(`/events/automated-events-to-control/all-potential-duplicates`);
  return data;
};

export const useGetAllPotentialDuplicateEventsQuery = () => {
  return useQuery({
    queryKey: potentialDuplicateEventsQueryKeys.all,
    queryFn: () => getAllPotentialDuplicateEvents(),
  });
};
